import { rem } from 'polished'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Image from 'components/Common/Image'
import BodyText from 'LuxKit/Typography/BodyText'

type Props = {
  brand: App.Tours.TourV2OfferBrand
}

const OperatorLogoContainer = styled.div`
  display: block;
  flex-shrink: 0;
  max-height: ${rem(75)};
  max-width: ${rem(150)};
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

function TourV2Operator({ brand }: Props) {
  const operatorLogo = brand.logoImage
  return (
    <Container>
      <div>
        <FormattedMessage
          id="/qWHXxuGQ9"
          defaultMessage="<label>Operated by</label><name>{brandName}</name>"
          description="Tour operator label and name on tour summary"
          values={{
            brandName: brand.name,
            label: (chunks) => <BodyText variant="medium" weight="bold">{chunks}</BodyText>,
            name: (chunks) => <BodyText variant="large">{chunks}</BodyText>,
          }}
        />
      </div>
      {operatorLogo && (
        <OperatorLogoContainer>
          <Image
            id={operatorLogo.id}
            dpr={2}
            quality="eco"
            width={150}
            alt={operatorLogo.title}
            aria-hidden="true"
          />
        </OperatorLogoContainer>
      )}
    </Container>
  )
}

export default TourV2Operator
